/**
 * @generated SignedSource<<8996fddd263f1e52d4e82bacf4571d56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DiagnosticsNotCompletedStudentsQuery$variables = {
  classIds?: ReadonlyArray<string> | null | undefined;
};
export type DiagnosticsNotCompletedStudentsQuery$data = {
  readonly allStudents: {
    readonly nodes: ReadonlyArray<{
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type DiagnosticsNotCompletedStudentsQuery = {
  response: DiagnosticsNotCompletedStudentsQuery$data;
  variables: DiagnosticsNotCompletedStudentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "classIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "classIds",
            "variableName": "classIds"
          },
          {
            "kind": "Literal",
            "name": "onlyWithOutstandingDiagnostic",
            "value": true
          },
          {
            "kind": "Literal",
            "name": "onlyWithResetDiagnostic",
            "value": null
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "StudentConnection",
    "kind": "LinkedField",
    "name": "allStudents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Student",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicUserId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiagnosticsNotCompletedStudentsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiagnosticsNotCompletedStudentsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "31d4437dfe828f2b0f2cc25fd7ce673b",
    "id": null,
    "metadata": {},
    "name": "DiagnosticsNotCompletedStudentsQuery",
    "operationKind": "query",
    "text": "query DiagnosticsNotCompletedStudentsQuery(\n  $classIds: [ID!]\n) {\n  allStudents(filter: {classIds: $classIds, onlyWithOutstandingDiagnostic: true}, first: 100) {\n    nodes {\n      id\n      firstName\n      lastName\n      publicUserId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0bd336742d76c2bea48ff2ad33615cb6";

export default node;
